import { Fragment } from "react";

import { CopyBlock } from "custom-types/Directus";

const ProductsCopyBlocks: React.FC<{ blocks?: CopyBlock["copy_block"] }> = ({
  blocks,
}) =>
  blocks?.length ? (
    <section className="mt-section">
      {blocks.map((block) => (
        <Fragment key={block.header}>
          <h2 className="mb-sm">{block.header}</h2>
          <div
            className="more-information"
            dangerouslySetInnerHTML={{ __html: block.copy || "" }}
          />
        </Fragment>
      ))}
      <style jsx>{`
        .more-information :global(a) {
          color: var(--color-green);
        }
      `}</style>
    </section>
  ) : (
    <></>
  );

export default ProductsCopyBlocks;
